import { Customer, Location, TruckingCompany } from 'types';

/* Carrier Name (SCAC) */
export const formatTruckingCompany = (truckingCompany?: Partial<TruckingCompany> | null): string => {
  return !truckingCompany?.name
    ? truckingCompany?.scacCode ?? ''
    : !truckingCompany.scacCode
    ? truckingCompany.name
    : `${truckingCompany.name} (${truckingCompany.scacCode})`;
};

/* Location Name, State */
export const formatLocation = (location?: Partial<Location> | null): string => {
  const locationName = location?.name ?? '';
  return locationName && (!location?.state ? locationName : `${locationName}, ${location.state}`);
};

/* Account Name (Location Name, State) */
export const formatCustomer = (customer?: Partial<Customer> | null): string => {
  const customerName = customer?.name ?? '';
  const locationName = formatLocation(customer?.location);
  return customerName && (!locationName ? customerName : `${customerName} (${locationName})`);
};

/*
 * Normalize a comma-separated email string into a clean list: each entry trimmed, blanks dropped.
 * Callers rely on this so "no recipients" is always an empty array rather than [''] — the latter is
 * what a naive `''.split(',')` produces and it leaks a phantom empty recipient into saved data.
 */
export const parseEmailList = (value?: string | null): string[] =>
  (value ?? '').split(',').map(email => email.trim()).filter(Boolean);
